import { render, staticRenderFns } from "./shopIndex.vue?vue&type=template&id=bf8c0800&scoped=true"
import script from "./shopIndex.vue?vue&type=script&lang=js"
export * from "./shopIndex.vue?vue&type=script&lang=js"
import style0 from "./shopIndex.vue?vue&type=style&index=0&id=bf8c0800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8c0800",
  null
  
)

export default component.exports